export const needsConfirmation = (bill, referenceDate = new Date()) => {
  if (!bill.autopay) return false;
  if (bill.status !== "Pending") return false;
  const due = new Date(`${bill.dueDate}T00:00:00`);
  const today = new Date(referenceDate);
  today.setHours(0, 0, 0, 0);
  return due < today;
};

export const nextMonthlyDate = (dateStr) => {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setMonth(d.getMonth() + 1);
  return d.toISOString().slice(0, 10);
};
